import { CommonModule } from '@angular/common';
import { Component, ElementRef, HostListener, OnDestroy, ViewChild, inject } from '@angular/core';
import { RouterLink, RouterLinkActive } from '@angular/router';
import { TranslatePipe } from '@ngx-translate/core';
import { Subscription } from 'rxjs';
import { Lang, LangService } from '../../../core/services/lang.service';
import { LocalizedRoutesService } from '../../../core/routing/localized-routes.service';
import { CookieConsentService } from '../../../core/services/cookie-consent.service';

@Component({
  selector: 'app-footer',
  standalone: true,
  imports: [CommonModule, RouterLink, RouterLinkActive, TranslatePipe],
  templateUrl: './footer.html'
})
export class FooterComponent implements OnDestroy {
  readonly paths = inject(LocalizedRoutesService);
  readonly consent = inject(CookieConsentService);
  readonly currentYear = new Date().getFullYear();

  @ViewChild('langMenu') langMenuRef?: ElementRef<HTMLElement>;
  langMenuOpen = false;
  lang: Lang = 'fr';

  private langSub: Subscription;

  constructor(private langService: LangService) {
    this.langSub = this.langService.lang$.subscribe(l => this.lang = l);
  }

  ngOnDestroy(): void {
    this.langSub.unsubscribe();
  }

  toggleLangMenu(): void {
    this.langMenuOpen = !this.langMenuOpen;
  }

  setLang(next: Lang): void {
    this.langService.set(next);
    this.langMenuOpen = false;
  }

  @HostListener('document:click', ['$event'])
  onDocumentClick(event: MouseEvent): void {
    const target = event.target as Node;
    if (
      this.langMenuRef?.nativeElement &&
      !this.langMenuRef.nativeElement.contains(target)
    ) {
      this.langMenuOpen = false;
    }
  }
}
